import {Utils} from '../../app.base';
import {MsgBox, Vue} from '../../app.vues';

import SwbRetailerBizAreaListForSelect from './RetailerBizAreaListForSelect';
Vue.regist(SwbRetailerBizAreaListForSelect);
// 经营区域选择
export function showRetailerBizAreaSelectDlg(params, callback) {
    let selectIds = params["selectIds"] || [];
    let bizFormName = params["bizFormName"] || null;
    let filter = params["filter"] || {};
    let checkBox = params["checkBox"] == null ? true : params["checkBox"];
    let disabledSelect = Utils.isTrue(params["disabledSelect"]);
    let theDlg = Vue.$showDialog({
        title: "经营区域 - 选择",
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-retailer-biz-area-list-for-select :bizFormName="bizFormName" :checkBox="checkBox" :selectIds="selectIds" :disabledSelect="disabledSelect" :filter="filter" ref="swb_retailer_biz_area_list_for_select"></swb-retailer-biz-area-list-for-select>',
        data: {
            checkBox: checkBox,
            disabledSelect: disabledSelect,
            selectIds: selectIds,
            filter: filter,
            bizFormName: bizFormName,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_biz_area_list_for_select.getDlgResult() || {};
            if (result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbRetailerBizAreaSave from './RetailerBizAreaSave';
Vue.regist(SwbRetailerBizAreaSave);
// 经营区域保存
export function showRetailerBizAreaSaveDlg(params, callback) {
    let areaId = params["id"] || null;
    let theDlg = Vue.$showDialog({
        title: "经营区域 - 保存",
        width: 600,
        height: 400,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-retailer-biz-area-save :areaId="areaId" ref="swb_retailer_biz_area_save"></swb-retailer-biz-area-save>',
        data: {
            areaId: areaId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_biz_area_save.getDlgResult() || {};
            if (result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbRetailerBizAreaDetail from './RetailerBizAreaDetail';
Vue.regist(SwbRetailerBizAreaDetail);
// 经营区域详情
export function showRetailerBizAreaDetailDlg(params) {
    let areaId = params["id"] || [];
    let theDlg = Vue.$showDialog({
        title: '经营区域 - 查看',
        width: 500,
        height: 600,
        cancelVisible: true,
        cancelText: "关闭",
        okVisible: false,
        template: '<swb-retailer-biz-area-detail :areaId="areaId" ref="swb_retailer_biz_area_detail"></swb-retailer-biz-area-detail>',
        data: {
            areaId: areaId
        },
        okClicked: function () {
        }
    });
}
import SwbRetailerMgmtAreaSave from './RetailerMgmtAreaSave'
Vue.regist(SwbRetailerMgmtAreaSave);
//
export function openMgmtAreaSaveDlg(params, callBack) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? '管理区域 - 新增' : '管理区域 - 编辑';
    Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        showCloseBtn: true,
        okVisible: true,
        template: '<swb-retailer-mgmt-area-save :item = "params" ref="swb_mgmt_area_save"></swb-retailer-mgmt-area-save>',
        data: {
            params: params,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mgmt_area_save.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbRetailerMgmtAreaForSelect from './RetailerMgmtAreaForSelect'
Vue.regist(SwbRetailerMgmtAreaForSelect);
export function openMgmtAreaTreeSelectDlg(dlgConfig = {}, callback) {
    //
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let enableSearch = dlgConfig["enableSearch"] != null ? dlgConfig["enableSearch"] : null;
    let isClickEvent = dlgConfig["isClickEvent"] != null ? dlgConfig["isClickEvent"] : true;
    let isRadio = dlgConfig["isRadio"] != null ? dlgConfig["isRadio"] : false;
    let noPostFilters = dlgConfig["noPostFilters"] != null ? dlgConfig["noPostFilters"] : false;
    Vue.$showDialog({
        title: '管理区域 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-mgmt-area-select :enableSearch="enableSearch" :isClickEvent="isClickEvent" :isRadio="isRadio" :noPostFilters="noPostFilters" ref="swb_mgmt_area_tree"></swb-mgmt-area-select>' +
        '</div>',
        data: {
            enableSearch: enableSearch,
            noPostFilters: noPostFilters,
            isClickEvent: isClickEvent,
            isRadio: isRadio,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mgmt_area_tree.getDlgResult() || {};
            callback(result.data);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/bizArea/dialog.js
// module id = 182
// module chunks = 0